var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivejourney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_201_1145",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9Z",
    fill: "#86EFAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9M17 9M17 9M1 9M9 1M17 9M9 17M1 9M9 17V16C5.13401 16 2 12.866 2 9H1H0C0 13.9706 4.02944 18 9 18V17ZM17 9H16C16 12.866 12.866 16 9 16V17V18C13.9706 18 18 13.9706 18 9H17ZM9 1V2C12.866 2 16 5.13401 16 9H17H18C18 4.02944 13.9706 0 9 0V1ZM9 1V0C4.02944 0 0 4.02944 0 9H1H2C2 5.13401 5.13401 2 9 2V1Z",
    fill: "#3A3428",
    mask: "url(#path-1-outside-1_201_1145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.334 5.66675L7.66732 12.3334L4.33398 9.00008",
    stroke: "#3A3428",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivejourney);
export default __webpack_public_path__ + "static/media/activejourney.ed8ac82fc1332f34f52ce8548b45c72e.svg";
export { ForwardRef as ReactComponent };